export const getBaseUrl = (url: string) => {
  if (url.startsWith("/i/")) {
    const splitUrl = url.split("/");
    return `/i/${splitUrl[2]}`;
  }
  return "/lp";
};
